// Drag and drop directive for file uploads
export default function dragDropDirective() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            let dragCounter = 0;
            
            element.on('dragenter', function(e) {
                e.preventDefault();
                e.stopPropagation();
                dragCounter++;
            });

            element.on('dragover', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                // Set dropEffect to allow dropping
                if (e.originalEvent && e.originalEvent.dataTransfer) {
                    e.originalEvent.dataTransfer.dropEffect = 'copy';
                } else if (e.dataTransfer) {
                    e.dataTransfer.dropEffect = 'copy';
                }
                
                // Call the function specified in the on-drag-over attribute
                if (attrs.onDragOver) {
                    scope.$evalAsync(function() {
                        scope.$eval(attrs.onDragOver, { $event: e });
                    });
                }
            });

            element.on('dragleave', function(e) {
                e.preventDefault();
                e.stopPropagation();
                dragCounter--;
                
                // Only trigger leave when we've actually left the element
                if (dragCounter === 0) {
                    // Call the function specified in the on-drag-leave attribute
                    if (attrs.onDragLeave) {
                        scope.$evalAsync(function() {
                            scope.$eval(attrs.onDragLeave, { $event: e });
                        });
                    }
                }
            });

            element.on('drop', function(e) {
                e.preventDefault();
                e.stopPropagation();
                dragCounter = 0;
                
                // Use the original event if available (jQuery wraps the event)
                const originalEvent = e.originalEvent || e;
                
                // Extract files immediately to avoid security clearing
                let extractedFiles = null;
                if (originalEvent.dataTransfer && originalEvent.dataTransfer.files && originalEvent.dataTransfer.files.length > 0) {
                    // Convert FileList to Array to preserve the files
                    extractedFiles = Array.from(originalEvent.dataTransfer.files);
                } else if (originalEvent.dataTransfer && originalEvent.dataTransfer.items && originalEvent.dataTransfer.items.length > 0) {
                    // Try the items approach
                    extractedFiles = [];
                    for (let i = 0; i < originalEvent.dataTransfer.items.length; i++) {
                        const item = originalEvent.dataTransfer.items[i];
                        if (item.kind === 'file') {
                            const file = item.getAsFile();
                            if (file) {
                                extractedFiles.push(file);
                            }
                        }
                    }
                }
                
                // Call the function specified in the on-drop attribute
                if (attrs.onDrop) {
                    scope.$evalAsync(function() {
                        // Pass the extracted files along with the event
                        scope.$eval(attrs.onDrop, { 
                            $event: originalEvent,
                            $files: extractedFiles 
                        });
                    });
                }
            });

            // Clean up event listeners on destroy
            scope.$on('$destroy', function() {
                element.off('dragenter dragover dragleave drop');
            });
        }
    };
} 